export const BLANK: Record<string, any> = Object.freeze(Object.create(null));
export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze([]);
